enum ApiErrorCode {
  Unknown, // eslint-disable-line no-unused-vars
  EntityNotFound, // eslint-disable-line no-unused-vars
  ExistsExceptions, // eslint-disable-line no-unused-vars
  BadRequest, // eslint-disable-line no-unused-vars
  Conflict, // eslint-disable-line no-unused-vars
}

export default ApiErrorCode;
